import React, { useState, useEffect } from "react";
import PAsidePanel from "../PAsidePanel";
import PAviItem from "./PAviItem";
import { vi } from "../../data";
import { CssTable, CssViZ, PAviItemLine } from "./PAviGroup";
export function PAviItems({
  products,
  appearance,
  opened = false,
  order = 1,
  id = 159428,
  sku = "gun_1",
  localized_name = "Xsolla Basic Blaster 1",
  prices = {
    USD: 1.99
  },
  virtual_currency_price = null,
  default_currency = "USD",
  enabled = true,
  permanent = false,
  image_url = "//cdn3.xsolla.com/img/misc/images/0c59a7698d4f66c1008b27ee752089b7.png",
  advertisement_type = null
}) {
  const [active, setActive] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let tim;
    if (active !== false) {
      if (!open) {
        tim = setTimeout(() => {
          setOpen(true);
        }, 100);
      }
    }
    else {
      setOpen(false);
    }
    return (() => {
      if (typeof tim !== 'undefined')
        clearTimeout(tim);
    });
  }, [active]);
  return (<CssTable open={open}>
    <div className="ui-table" style={{ position: "static" }}>

      <PAsidePanel z={false} isOpen={active !== false ? true : false} handleClose={() => setActive(false)} header={localized_name}>
        {active !== false && !!vi[active] && <PAviItem order={active} id={vi[active]['id']} sku={vi[active]['sku']} localized_name={vi[active]['localized_name']} prices={{
          "USD": 1.99
        }} virtual_currency_price={vi[active]['virtual_currency_price']} default_currency="USD" enabled={true} permanent={false} image_url={vi[active]['image_url']} advertisement_type={null} name="Xsolla Rocket Launcher" img="https://res.cloudinary.com/maiik/image/upload/v1564043663/Xsolla_PA/temp/Frame_3.10.png" status="active" />}
      </PAsidePanel>


      <div className="ui-table__head">
        {appearance !== 'connector' && <div className="ui-table__column ui-table__column--indentation-sm" style={{ flexShrink: 0, width: 60 }}>
          Order
          </div>}
        <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-md" style={{ maxWidth: "45%" }}>
          Product
          </div>

        {appearance !== 'connector' && <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{ maxWidth: "15%" }}>
          Label
          </div>}

        <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{ maxWidth: "15%" }}>
          Price
          </div>


        {appearance === 'connector' && <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{ flexShrink: 0, width: "15%" }}>
          Xsolla SKU
          </div>}

        {appearance === 'connector' && <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{ flexShrink: 0, width: "10%" }}>
          Status
          </div>}


        {appearance === 'connector' && <div className="ui-table__column ui-table__column--indentation-sm" style={{ flexShrink: 0, width: "15%" }}>
          Xbox SKU
          </div>}

        {appearance !== 'connector' && <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{ flexShrink: 0, width: "15%" }}>
          Status
          </div>}

        <div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{ maxWidth: "10%" }} />
      </div>
      <div className="ui-table__body" style={{ zIndex: 0 }}>

        {active !== false && <CssViZ className={`xsui-backdrop${active !== false ? " xsui-backdrop--show" : ""}`} style={{
          cursor: 'w-resize',
        }} onClick={() => {
          setActive(false);
        }}></CssViZ>}

        {products.map((oneItem, ind) => {
          return <PAviItemLine {...oneItem} active={active} opened={active !== false ? true : false} appearance={appearance} key={ind} order={ind} handleClick={(newAct) => { setActive(newAct); }} />;
        })}

      </div>
    </div>
  </CssTable>);
}
